var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-lg": "" } },
    [
      _vm.loadingCategories
        ? _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            _vm._l(3, function(n) {
              return _c(
                "v-flex",
                { key: n, attrs: { xs12: "", sm6: "", lg3: "" } },
                [_c("v-skeleton-loader", { attrs: { type: "card" } })],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _c(
        "v-layout",
        {
          staticClass: "category-products mb-10 mt-10 justify-center",
          attrs: { row: "", wrap: "" }
        },
        _vm._l(_vm.allProducts, function(product) {
          return _c(
            "v-flex",
            { key: product.id, attrs: { xs12: "", sm6: "", md6: "", lg4: "" } },
            [
              _c(
                "v-card",
                { staticClass: "text-center transparent", attrs: { flat: "" } },
                [
                  _c(
                    "h3",
                    {
                      staticClass: "product-title mb-2",
                      on: {
                        click: function($event) {
                          return _vm.$router.push("/product/" + product.alias)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(product.name) + " ")]
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "v-img",
                        {
                          staticClass: "cursor-pointer",
                          attrs: { src: _vm.getProductImage(product.imageUrl) },
                          on: {
                            click: function($event) {
                              return _vm.$router.push(
                                "/product/" + product.alias
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-container",
                            {
                              staticStyle: { width: "90%", "margin-top": "35%" }
                            },
                            [
                              _c(
                                "v-row",
                                [
                                  _c("v-col", [
                                    _c(
                                      "h2",
                                      {
                                        staticClass:
                                          "white--text font-weight-bold"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("homepage.currency", {
                                                price: _vm.formatThousands(
                                                  product.amountWithVat
                                                )
                                              })
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]),
                                  _c(
                                    "v-col",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "white--text",
                                          staticStyle: {
                                            "vertical-align": "middle",
                                            "text-transform": "lowercase"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("cart.addToCart"))
                                          )
                                        ]
                                      ),
                                      _c("img", {
                                        staticClass: "cart-image ml-1",
                                        staticStyle: {
                                          height: "16px",
                                          "line-height": "16px"
                                        },
                                        attrs: {
                                          src: require("../../assets/shoping_bag_white.svg")
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("v-card-text", { staticClass: "description pt-2" }, [
                    _c("strong", {
                      domProps: { innerHTML: _vm._s(product.shortDescription) }
                    })
                  ])
                ],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }